import { render } from "./CourseList.vue?vue&type=template&id=2599f12b"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Terms/CourseList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2599f12b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2599f12b', __exports__)) {
    api.reload('2599f12b', __exports__)
  }
  
  module.hot.accept("./CourseList.vue?vue&type=template&id=2599f12b", () => {
    api.rerender('2599f12b', render)
  })

}


export default __exports__